"use client";

import React from "react";
const lenders = [{
  id: 1,
  name: "Rigorous Vetting",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/vetting-standard.png"
}, {
  id: 2,
  name: "Bank-Grade Security",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/security-standard.png"
}, {
  id: 3,
  name: "Diversity of Choice",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/diversity-standard.png"
}, {
  id: 4,
  name: "Compliance Verified",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/compliance-standard.png"
}, {
  id: 5,
  name: "Expert Integration",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/integration-standard.png"
}, {
  id: 6,
  name: "Tech-Forward Infrastructure",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1605423/img/tech-standard.png"
}];
export default function OurNetworkOfLenders() {
  return <section data-section-id="153348" id="our-network-standards" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-primary mb-12 md:mb-16 tracking-tighter">
          Experts, <span className="italic font-serif text-secondary">One Connection</span>: Our Network Standards
        </h2>
        
        <div className="flex flex-wrap justify-center items-center gap-10 md:gap-16 lg:gap-20">
          {lenders.map((lender, i) => <div key={lender.id} data-index={i} className="flex items-center justify-center w-28 md:w-36 h-12 md:h-16 transition-all duration-500 opacity-70 hover:opacity-100 hover:scale-105">
              <img src={lender.logoUrl} alt={`${lender.name} badge`} className="max-w-full max-h-full object-contain filter brightness-90 contrast-125" loading="lazy" />
            </div>)}
        </div>
      </div>
    </section>;
}